import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import {Option} from "@/pages/get-don/tasks.types.ts";

interface Props {
 options: Option[];
 value: string;
 onChange: (ids: string) => void;

}
const Checkbox = ({options, value, onChange}: Props ) => {
  return (
    <div className="flex flex-col items-start w-full gap-2">
      {options.map((item) => {
        const isSelected = value === item.id;

        return (
          <VibratingButton
            key={item.id}
            vibrationType="selection"
            className={`p-px rounded-xl w-full cursor-pointer transition-300 ${
              isSelected
                ? "bg-yellow-linear shadow-[0_7px_33px_-24px_rgba(235,161,50,0.24)]"
                : "bg-transparent"
            }`}
            onClick={() => onChange(item.id)}
          >
            <div className="bg-gray-4 rounded-xl">
            <div
              className={`py-2.5 px-3 w-full rounded-xl transition-300 ${
                isSelected
                  ? "bg-[linear-gradient(83deg,rgba(251,199,108,0.08)_-31px,rgba(235,161,50,0.08)_100px)]"
                  : "bg-gray-4"
              }`}
            >
              <div className="flex items-start justify-between w-full gap-3">
                <p className="text-sm font-semibold text-white text-start leading-5">
                  {item.title}
                </p>

                <div className={`w-6 h-6 shrink-0 rounded-full border border-white/08 flex items-center justify-center transition-200
                  ${isSelected ? "bg-yellow-linear border-yellow-linear" : ""}`}
                >
                  {isSelected && (
                    <div className="w-3 h-3 rounded-full bg-white" />
                  )}
                </div>
              </div>
            </div>
            </div>
          </VibratingButton>
        );
      })}
    </div>
  );
};

export default Checkbox;
